import {ChangeDetectionStrategy, Component, Inject, Input, OnInit} from '@angular/core';
import {Address} from "../../../models/address.model";
import * as _ from "lodash";
import {AddressFacadeService} from "../../state/addresses-facade.service";
import {NgxPermissionsService} from "ngx-permissions";
import {AddressRequestType} from "../../types/address-request.type";
import {AddressResolvingInfo} from "../../../models/address-resolving-info.model";

require('./address-quality.scss');
@Component({
  standalone: false,
  selector: 'app-address-quality',
  templateUrl: './address-quality.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressQualityComponent implements OnInit {

  @Input() address: AddressResolvingInfo;
  @Input() query: any;
  @Input() type: AddressRequestType;

  public canViewResolver: boolean = true;
  public canUpdateResolver: boolean;
  public qualityGroupFill: object;

  public addressRequestType: typeof AddressRequestType = AddressRequestType;

  constructor(@Inject(AddressFacadeService) private addressFacadeService: AddressFacadeService,
              @Inject(NgxPermissionsService) private permissionsService: NgxPermissionsService,
              @Inject('$timeout') private $timeout) {
  }

  ngOnInit() {
    this.qualityGroupFill = {
      none: '#7E7E7E',
      low: '#F8522D',
      medium: '#F8A72D',
      high: '#65BF57'
    }
    this.canViewResolver = true;

    this.permissionsService.hasPermission('addressResolver.list').then((hasPermission) => {
      this.canViewResolver = hasPermission;
      this.$timeout(0).then(() => {});
    });

    this.permissionsService.hasPermission('addressResolver.update').then((hasPermission) => {
      this.canUpdateResolver = hasPermission;
      this.$timeout(0).then(() => {});
    });

  }


  onSelectAddress(event) {
    event.stopPropagation()
    if (this.canUpdateResolver) {
      this.addressFacadeService.setAddressId(this.address.entryId, this.query, this.type);
    }
  }

}
